module.exports = __webpack_public_path__ + "static/media/MrWalkerCase.d17d26de.jpg";